/**
 * Form Cache Busting
 * Allows forms to be cached
 */
const forms = Array.from(document.querySelectorAll("form.fui-form"));
if (forms.length > 0) {
  updateForms(forms);
}

async function getCsrfToken() {
  const response = await fetch("/actions/users/session-info", {
    headers: {
      Accept: "application/json",
    },
  });
  const json = await response.json();
  return json;
}

async function updateForms(forms) {
  const token = await getCsrfToken();
  forms.map((f) => {
    const csrfInput = f.querySelector('input[name="CRAFT_CSRF_TOKEN"]');
    csrfInput.value = token.csrfTokenValue;
  });
}
